import { render, staticRenderFns } from "./DragAndDropImage.vue?vue&type=template&id=e4f1fbfa&scoped=true"
import script from "./DragAndDropImage.vue?vue&type=script&lang=js"
export * from "./DragAndDropImage.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropImage.vue?vue&type=style&index=0&id=e4f1fbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f1fbfa",
  null
  
)

export default component.exports